// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1EEUO","title":"Info_title__2B5Gx","selects":"Info_selects__tBNqw","requiredAsterisk":"Info_requiredAsterisk__qWDdj"};